// extracted by mini-css-extract-plugin
module.exports = {"iconButtons":"GroupTable_iconButtons__2LNO-","actions":"GroupTable_actions__2bBzQ","deleteModalFooter":"GroupTable_deleteModalFooter__1youD"};